export const triggerHaloAnimation = (targetElement, avatarId, level, mode = 'flex') => {
    try {
        if (!targetElement) return;

        const avatarSize = targetElement.getBoundingClientRect().width || 120;
        const haloSize = avatarSize * (0.9 + level * 0.15);

        // 1. Get or Create Container
        let haloContainer = targetElement.querySelector(".avatar-halo-container");
        if (!haloContainer) {
            haloContainer = document.createElement("div");
            haloContainer.className = "avatar-halo-container";
            
            // Shared Styles
            haloContainer.style.position = "absolute";
            haloContainer.style.top = "0";
            haloContainer.style.left = "0";
            haloContainer.style.width = "100%";
            haloContainer.style.height = "100%";
            haloContainer.style.pointerEvents = "none";
            haloContainer.style.zIndex = "0";

            // Mode specific styles
            if (mode === 'flex') {
                haloContainer.style.display = "flex";
                haloContainer.style.justifyContent = "center";
                haloContainer.style.alignItems = "center";
            }
            
            targetElement.appendChild(haloContainer);
        }

        // 2. Throttle
        const existingHalo = haloContainer.querySelector(`.avatar-halo-${avatarId}`);
        if (existingHalo) return;

        // 3. Create Halo
        const haloElement = document.createElement("span");
        haloElement.className = `avatar-halo-${avatarId}`;
        haloContainer.appendChild(haloElement);

        // 4. Style Halo
        haloElement.style.position = 'absolute';
        haloElement.style.width = `${haloSize}px`;
        haloElement.style.height = `${haloSize}px`;
        haloElement.style.borderRadius = "50%";
        haloElement.style.background = "rgba(138,204,202, 0.7)";
        haloElement.style.boxShadow = `0 0 ${haloSize / 3}px rgba(138,204,202, 1)`;
        haloElement.style.animation = "haloEffect 1s ease-out";
        haloElement.style.opacity = "1";
        haloElement.style.flexShrink = "0";

        // Positioning Logic
        if (mode === 'manual') {
            // For Avatar.js (Leaflet)
            haloElement.style.top = `${avatarSize / 2 - haloSize / 2}px`;
            haloElement.style.left = `${avatarSize / 2 - haloSize / 2}px`;
        } 
        // Note: 'flex' mode doesn't need top/left setting, CSS flex handles it

        // 5. Cleanup Animation
        setTimeout(() => {
            haloElement.style.opacity = "0";
            haloElement.style.transition = "opacity 0.5s ease-out";
            setTimeout(() => {
                if (haloElement.parentNode === haloContainer) {
                    haloContainer.removeChild(haloElement);
                }
            }, 500);
        }, 1000);

    } catch (error) {
        console.error("Halo Animation Error:", error);
    }
};